function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import ClassNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Checkbox, LoadingSpinner, RadioGroup, Radio, NumberField, Picker, Item } from '@deephaven/components';
import { GridRange, GridUtils } from '@deephaven/grid';
import { vsWarning } from '@deephaven/icons';
import { TimeUtils } from '@deephaven/utils';
import { nanoid } from 'nanoid';
import "./TableCsvExporter.css";
import Log from '@deephaven/log';
import IrisGridUtils from "../IrisGridUtils.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var log = Log.module('TableCsvExporter');
class TableCsvExporter extends Component {
  static getDateString(dh) {
    return dh.i18n.DateTimeFormat.format(TableCsvExporter.FILENAME_DATE_FORMAT, new Date());
  }
  constructor(props) {
    super(props);
    this.handleDownloadClick = this.handleDownloadClick.bind(this);
    this.handleDownloadRowOptionChanged = this.handleDownloadRowOptionChanged.bind(this);
    this.handleCustomizedDownloadRowOptionChanged = this.handleCustomizedDownloadRowOptionChanged.bind(this);
    this.handleCustomizedDownloadRowsChanged = this.handleCustomizedDownloadRowsChanged.bind(this);
    this.handleIncludeColumnHeadersChanged = this.handleIncludeColumnHeadersChanged.bind(this);
    this.handleIncludeHiddenColumnsChanged = this.handleIncludeHiddenColumnsChanged.bind(this);
    this.handleUseUnformattedValuesChanged = this.handleUseUnformattedValuesChanged.bind(this);
    var model = props.model,
      name = props.name;
    this.state = {
      fileName: "".concat(name, "-").concat(TableCsvExporter.getDateString(model.dh), ".csv"),
      downloadRowOption: TableCsvExporter.DOWNLOAD_ROW_OPTIONS.ALL_ROWS,
      customizedDownloadRowOption: TableCsvExporter.CUSTOMIZED_ROWS_OPTIONS.FIRST,
      customizedDownloadRows: TableCsvExporter.DEFAULT_DOWNLOAD_ROWS,
      includeColumnHeaders: true,
      includeHiddenColumns: false,
      useUnformattedValues: false,
      errorMessage: null,
      id: nanoid()
    };
  }
  getSnapshotRanges() {
    var _this$props = this.props,
      model = _this$props.model,
      selectedRanges = _this$props.selectedRanges;
    var _this$state = this.state,
      downloadRowOption = _this$state.downloadRowOption,
      customizedDownloadRowOption = _this$state.customizedDownloadRowOption,
      customizedDownloadRows = _this$state.customizedDownloadRows;
    var rowCount = model.rowCount,
      columnCount = model.columnCount;
    var snapshotRanges = [];
    switch (downloadRowOption) {
      case TableCsvExporter.DOWNLOAD_ROW_OPTIONS.ALL_ROWS:
        snapshotRanges.push(new GridRange(0, 0, columnCount - 1, rowCount - 1));
        break;
      case TableCsvExporter.DOWNLOAD_ROW_OPTIONS.SELECTED_ROWS:
        snapshotRanges = selectedRanges.map(range => _objectSpread(_objectSpread({}, range), {}, {
          startColumn: 0,
          endColumn: columnCount - 1
        })).sort((rangeA, rangeB) => {
          if (rangeA.startRow != null && rangeB.startRow != null) {
            return rangeA.startRow - rangeB.startRow;
          }
          return 0;
        });
        break;
      case TableCsvExporter.DOWNLOAD_ROW_OPTIONS.CUSTOMIZED_ROWS:
        switch (customizedDownloadRowOption) {
          case TableCsvExporter.CUSTOMIZED_ROWS_OPTIONS.FIRST:
            snapshotRanges.push(new GridRange(0, 0, columnCount - 1, Math.min(customizedDownloadRows - 1, rowCount - 1)));
            break;
          case TableCsvExporter.CUSTOMIZED_ROWS_OPTIONS.LAST:
            snapshotRanges.push(new GridRange(0, Math.max(0, rowCount - customizedDownloadRows), columnCount - 1, rowCount - 1));
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
    return snapshotRanges;
  }
  getModelRanges(ranges) {
    var _this$props2 = this.props,
      userColumnWidths = _this$props2.userColumnWidths,
      movedColumns = _this$props2.movedColumns;
    var includeHiddenColumns = this.state.includeHiddenColumns;
    var hiddenColumns = IrisGridUtils.getHiddenColumns(userColumnWidths);
    var modelRanges = GridUtils.getModelRanges(ranges, movedColumns);
    if (!includeHiddenColumns && hiddenColumns.length > 0) {
      var subtractRanges = hiddenColumns.map(GridRange.makeColumn);
      modelRanges = GridRange.subtractRangesFromRanges(modelRanges, subtractRanges);
    }
    return modelRanges;
  }
  resetDownloadState() {
    this.setState({
      errorMessage: null
    });
  }
  handleDownloadClick() {
    var _this = this;
    return _asyncToGenerator(function* () {
      var _this$props3 = _this.props,
        model = _this$props3.model,
        isDownloading = _this$props3.isDownloading,
        onDownloadStart = _this$props3.onDownloadStart,
        onDownload = _this$props3.onDownload,
        onCancel = _this$props3.onCancel;
      var _this$state2 = _this.state,
        fileName = _this$state2.fileName,
        includeColumnHeaders = _this$state2.includeColumnHeaders,
        useUnformattedValues = _this$state2.useUnformattedValues;
      if (isDownloading) {
        onCancel();
        return;
      }
      _this.resetDownloadState();
      var snapshotRanges = _this.getSnapshotRanges();
      var modelRanges = _this.getModelRanges(snapshotRanges);
      if (_this.validateOptionInput()) {
        onDownloadStart();
        try {
          var frozenTable = yield model.export();
          var tableSubscription = frozenTable.setViewport(0, 0);
          yield tableSubscription.getViewportData();
          onDownload(fileName, frozenTable, tableSubscription, snapshotRanges, modelRanges, includeColumnHeaders, useUnformattedValues);
        } catch (error) {
          log.error('CSV download failed', error);
          _this.setState({
            errorMessage: /*#__PURE__*/_jsxs("p", {
              children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: vsWarning
              }), " ", "".concat(error)]
            })
          });
          onCancel();
        }
      }
    })();
  }
  handleDownloadRowOptionChanged(value) {
    this.setState({
      downloadRowOption: value
    });
  }
  handleCustomizedDownloadRowOptionChanged(value) {
    if (value !== null) {
      this.setState({
        customizedDownloadRowOption: String(value)
      });
    }
  }
  handleCustomizedDownloadRowsChanged(value) {
    this.setState({
      customizedDownloadRows: value
    });
  }
  handleIncludeColumnHeadersChanged() {
    this.setState(_ref => {
      var includeColumnHeaders = _ref.includeColumnHeaders;
      return {
        includeColumnHeaders: !includeColumnHeaders
      };
    });
  }
  handleIncludeHiddenColumnsChanged() {
    this.setState(_ref2 => {
      var includeHiddenColumns = _ref2.includeHiddenColumns;
      return {
        includeHiddenColumns: !includeHiddenColumns
      };
    });
  }
  handleUseUnformattedValuesChanged() {
    this.setState(_ref3 => {
      var useUnformattedValues = _ref3.useUnformattedValues;
      return {
        useUnformattedValues: !useUnformattedValues
      };
    });
  }
  validateOptionInput() {
    var selectedRanges = this.props.selectedRanges;
    var _this$state3 = this.state,
      downloadRowOption = _this$state3.downloadRowOption,
      customizedDownloadRows = _this$state3.customizedDownloadRows;
    if (downloadRowOption === TableCsvExporter.DOWNLOAD_ROW_OPTIONS.SELECTED_ROWS && selectedRanges.length === 0) {
      this.setState({
        errorMessage: /*#__PURE__*/_jsxs("p", {
          children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: vsWarning
          }), " No rows selected. Please select some rows in the table."]
        })
      });
      return false;
    }
    if (downloadRowOption === TableCsvExporter.DOWNLOAD_ROW_OPTIONS.CUSTOMIZED_ROWS && customizedDownloadRows <= 0) {
      this.setState({
        errorMessage: /*#__PURE__*/_jsxs("p", {
          children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: vsWarning
          }), " Number of rows to output must be greater than 0"]
        })
      });
      return false;
    }
    return true;
  }
  render() {
    var _this$props4 = this.props,
      model = _this$props4.model,
      isDownloading = _this$props4.isDownloading,
      tableDownloadProgress = _this$props4.tableDownloadProgress,
      tableDownloadEstimatedTime = _this$props4.tableDownloadEstimatedTime,
      selectedRanges = _this$props4.selectedRanges,
      tableDownloadStatus = _this$props4.tableDownloadStatus;
    var _this$state4 = this.state,
      fileName = _this$state4.fileName,
      downloadRowOption = _this$state4.downloadRowOption,
      customizedDownloadRowOption = _this$state4.customizedDownloadRowOption,
      customizedDownloadRows = _this$state4.customizedDownloadRows,
      includeColumnHeaders = _this$state4.includeColumnHeaders,
      includeHiddenColumns = _this$state4.includeHiddenColumns,
      useUnformattedValues = _this$state4.useUnformattedValues,
      errorMessage = _this$state4.errorMessage,
      id = _this$state4.id;
    var rowCount = model.rowCount;
    return /*#__PURE__*/_jsxs("div", {
      className: "table-csv-exporter",
      children: [/*#__PURE__*/_jsx("div", {
        id: "download-rows-label",
        className: "section-title",
        children: "Download Rows"
      }), /*#__PURE__*/_jsx("div", {
        className: "form-group",
        children: /*#__PURE__*/_jsxs(RadioGroup, {
          "aria-labelledby": "download-rows-label",
          onChange: this.handleDownloadRowOptionChanged,
          value: downloadRowOption,
          isDisabled: isDownloading,
          children: [/*#__PURE__*/_jsxs(Radio, {
            value: TableCsvExporter.DOWNLOAD_ROW_OPTIONS.ALL_ROWS,
            "data-testid": "radio-csv-exporter-download-all",
            children: ["All Rows", /*#__PURE__*/_jsx("span", {
              className: "text-muted ml-2",
              children: "(".concat(rowCount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'), " rows)")
            })]
          }), /*#__PURE__*/_jsxs(Radio, {
            value: TableCsvExporter.DOWNLOAD_ROW_OPTIONS.SELECTED_ROWS,
            "data-testid": "radio-csv-exporter-only-selected",
            children: ["Only Selected Rows", /*#__PURE__*/_jsx("span", {
              className: "text-muted ml-2",
              children: selectedRanges.length > 0 ? "(".concat(GridRange.rowCount(selectedRanges).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'), " rows)") : null
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "d-flex",
            children: [/*#__PURE__*/_jsx(Radio, {
              value: TableCsvExporter.DOWNLOAD_ROW_OPTIONS.CUSTOMIZED_ROWS,
              "data-testid": "radio-csv-exporter-customized-rows",
              margin: "0",
              "aria-label": "Download a custom number of rows"
            }), /*#__PURE__*/_jsxs("div", {
              className: "radio-input-row",
              role: "presentation",
              onClick: () => {
                this.setState({
                  downloadRowOption: TableCsvExporter.DOWNLOAD_ROW_OPTIONS.CUSTOMIZED_ROWS
                });
              },
              children: [/*#__PURE__*/_jsxs(Picker, {
                selectedKey: customizedDownloadRowOption,
                "data-testid": "select-csv-exporter-customized-rows",
                isDisabled: isDownloading,
                onChange: this.handleCustomizedDownloadRowOptionChanged,
                "aria-label": "First or last number of rows",
                flex: true,
                children: [/*#__PURE__*/_jsx(Item, {
                  children: "First"
                }, "FIRST"), /*#__PURE__*/_jsx(Item, {
                  children: "Last"
                }, "LAST")]
              }), /*#__PURE__*/_jsx(NumberField, {
                id: "customizedRows-".concat(id),
                "data-testid": "input-csv-exporter-customized-rows",
                name: "customizedRows-".concat(id),
                minValue: 1,
                defaultValue: 100,
                value: customizedDownloadRows,
                width: "100%",
                minWidth: 0,
                isDisabled: isDownloading,
                onChange: this.handleCustomizedDownloadRowsChanged,
                "aria-label": "Number of rows to download",
                flex: true
              }), /*#__PURE__*/_jsx("div", {
                children: "Rows"
              })]
            })]
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "form-group",
        children: [/*#__PURE__*/_jsx("label", {
          htmlFor: "customizedRows-".concat(id),
          children: "File Name"
        }), /*#__PURE__*/_jsx("input", {
          type: "text",
          className: "form-control",
          id: "filename-".concat(id),
          "data-testid": "input-csv-exporter-file-name",
          name: "filename-".concat(id),
          value: fileName,
          onChange: event => {
            this.setState({
              fileName: event.target.value
            });
          },
          disabled: isDownloading
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "checkbox-options",
        children: [/*#__PURE__*/_jsx(Checkbox, {
          checked: includeColumnHeaders,
          onChange: this.handleIncludeColumnHeadersChanged,
          children: "Include column headers"
        }), /*#__PURE__*/_jsx(Checkbox, {
          checked: includeHiddenColumns,
          onChange: this.handleIncludeHiddenColumnsChanged,
          children: "Include hidden columns"
        }), /*#__PURE__*/_jsx(Checkbox, {
          checked: useUnformattedValues,
          onChange: this.handleUseUnformattedValuesChanged,
          children: "Use unformatted values"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "section-footer flex-column",
        children: [errorMessage != null && /*#__PURE__*/_jsx("div", {
          className: "error-message",
          children: errorMessage
        }), tableDownloadStatus && /*#__PURE__*/_jsxs("div", {
          className: "download-status",
          children: [(tableDownloadStatus === TableCsvExporter.DOWNLOAD_STATUS.DOWNLOADING || tableDownloadStatus === TableCsvExporter.DOWNLOAD_STATUS.INITIATING) && /*#__PURE__*/_jsxs(_Fragment, {
            children: [tableDownloadStatus === TableCsvExporter.DOWNLOAD_STATUS.INITIATING && /*#__PURE__*/_jsx("div", {
              className: "text-muted",
              children: "Starting Download..."
            }), tableDownloadStatus === TableCsvExporter.DOWNLOAD_STATUS.DOWNLOADING && /*#__PURE__*/_jsxs("div", {
              className: "text-muted d-flex justify-content-between",
              children: [/*#__PURE__*/_jsx("span", {
                children: tableDownloadEstimatedTime || tableDownloadEstimatedTime === 0 ? "Estimated time: ".concat(TimeUtils.formatElapsedTime(tableDownloadEstimatedTime)) : null
              }), /*#__PURE__*/_jsx("span", {
                children: "".concat(tableDownloadProgress, "%")
              })]
            })]
          }), tableDownloadStatus === TableCsvExporter.DOWNLOAD_STATUS.FINISHED && /*#__PURE__*/_jsx("div", {
            className: "text-muted text-right",
            children: "Download Completed"
          }), tableDownloadStatus === TableCsvExporter.DOWNLOAD_STATUS.CANCELED && /*#__PURE__*/_jsx("div", {
            className: "text-muted",
            children: "Download Canceled"
          }), (tableDownloadStatus === TableCsvExporter.DOWNLOAD_STATUS.DOWNLOADING || tableDownloadStatus === TableCsvExporter.DOWNLOAD_STATUS.INITIATING) && /*#__PURE__*/_jsx("div", {
            className: "progress",
            children: /*#__PURE__*/_jsx("div", {
              className: "progress-bar progress-bar-striped progress-bar-animated",
              style: {
                width: "".concat(tableDownloadProgress, "%")
              }
            })
          }), tableDownloadStatus === TableCsvExporter.DOWNLOAD_STATUS.FINISHED && /*#__PURE__*/_jsx("div", {
            className: "progress",
            children: /*#__PURE__*/_jsx("div", {
              className: "progress-bar bg-success",
              style: {
                width: "".concat(tableDownloadProgress, "%")
              }
            })
          })]
        }), /*#__PURE__*/_jsxs(Button, {
          kind: "primary",
          "data-testid": "btn-csv-exporter-download",
          className: ClassNames('btn-downloading', {
            'btn-spinner btn-cancelable': isDownloading
          }),
          onClick: this.handleDownloadClick,
          children: [isDownloading && /*#__PURE__*/_jsxs("span", {
            children: [/*#__PURE__*/_jsx(LoadingSpinner, {
              className: "mr-2 loading-spinner-vertical-align"
            }), /*#__PURE__*/_jsx("span", {
              className: "btn-normal-content",
              children: "Downloading"
            }), /*#__PURE__*/_jsx("span", {
              className: "btn-hover-content",
              children: "Cancel"
            })]
          }), !isDownloading && 'Download']
        })]
      })]
    });
  }
}
_defineProperty(TableCsvExporter, "FILENAME_DATE_FORMAT", 'yyyy-MM-dd-HHmmss');
_defineProperty(TableCsvExporter, "DOWNLOAD_STATUS", {
  INITIATING: 'INITIATING',
  DOWNLOADING: 'DOWNLOADING',
  FINISHED: 'FINISHED',
  CANCELED: 'CANCELED'
});
_defineProperty(TableCsvExporter, "DOWNLOAD_ROW_OPTIONS", {
  ALL_ROWS: 'ALL_ROWS',
  SELECTED_ROWS: 'SELECTED_ROWS',
  CUSTOMIZED_ROWS: 'CUSTOMIZED_ROWS'
});
_defineProperty(TableCsvExporter, "CUSTOMIZED_ROWS_OPTIONS", {
  FIRST: 'FIRST',
  LAST: 'LAST'
});
_defineProperty(TableCsvExporter, "DEFAULT_DOWNLOAD_ROWS", 100);
_defineProperty(TableCsvExporter, "defaultProps", {
  onDownloadStart: () => undefined,
  isDownloading: false,
  tableDownloadStatus: '',
  tableDownloadProgress: 0,
  tableDownloadEstimatedTime: null,
  selectedRanges: []
});
export default TableCsvExporter;
//# sourceMappingURL=TableCsvExporter.js.map